import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { RouterModule } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ModalModule } from 'ngx-bootstrap/modal';
// import { ExternalComponent } from './external/external.component';

import { TabsModule } from 'ngx-bootstrap/tabs';
import { DataTablesModule } from 'angular-datatables';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { CoreSharedModule } from './core/core-shared.module';

import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { PostmethodService } from './app-config/postmethod.service';
import { LoaderInterceptor } from './app-config/loader.interceptor';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { QRCodeModule } from 'angularx-qrcode';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { MobilePaymentComponent } from './external/mobile-payment/mobile-payment.component';
import { RiderPolicyComponent } from './external/rider-policy/rider-policy.component';
import { CustomerPolicyComponent } from './external/customer-policy/customer-policy.component';
import { SignalRModule } from 'ng2-signalr';
import { SignalRConfiguration } from 'ng2-signalr';
export function createConfig(): SignalRConfiguration {
  const c = new SignalRConfiguration();
  c.hubName = 'chatHub';
  // c.qs = { user: 'Admin' };
  c.url = environment.ChatUrl;
  c.logging = true;
  
  // >= v5.0.0
  c.executeEventsInZone = true; // optional, default is true
  c.executeErrorsInZone = false; // optional, default is false
  c.executeStatusChangeInZone = true; // optional, default is true
  return c;
}

@NgModule({
  declarations: [
    AppComponent,
    MobilePaymentComponent,
    RiderPolicyComponent,
    CustomerPolicyComponent
    // ExternalComponent,
  ],
  imports: [
    SignalRModule.forRoot(createConfig),
    BrowserModule,
    BrowserAnimationsModule,
    ModalModule.forRoot(),
    TabsModule,
    DataTablesModule,
    ProgressbarModule,
    BsDatepickerModule,
    AppRoutingModule,
    RouterModule,
    SharedModule,
    QRCodeModule,
    HttpClientModule,
    CoreSharedModule,
    AutocompleteLibModule,
    NgMultiSelectDropDownModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-full-width',
      preventDuplicates: true,
      closeButton:true,
      // tapToDismiss:false,
      // disableTimeOut:true,
    }),
  ],
  providers: [  PostmethodService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }
